// #region Dependencias
import i18n from 'i18next'
import I18NextHttpBackend from 'i18next-http-backend'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { EN, ES } from 'utils/constants'
// #endregion Dependencias

/**
 * Inicializa la librería de internacionalización i18next
 */
i18n
  .use(I18NextHttpBackend)
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/global.json'
    },
    fallbackLng: EN.value,
    interpolation: { escapeValue: false },
    supportedLngs: [EN.value, ES.value]
  })

export default i18n
